import { useQuery } from "@tanstack/react-query";
import type { StoreId } from "@KassaroAB/shared/types/ids";
import { getHelpContextApi } from "../api/helpApi";

export const useGetHelpContextQuery = (route: string, storeId: StoreId | null) =>
  useQuery({
    queryKey: ["help", "context", route, storeId],
    queryFn: () => getHelpContextApi(route, storeId),
    staleTime: 5 * 60 * 1000,
  });
